module.exports = __webpack_public_path__ + "static/media/brain-icon.00541589.gif";